<template>
    <IndexModelLayout
        :createRoute="$route('admin::vacation-message-defaults.create')"
        :modelNamePlural="__('admin::vacation-message-defaults.vacation-message-defaults')"
    >

        <Table
            :headings="[
                __('admin::labels.name'),
                __('admin::labels.priority'),
                __('admin::labels.is_active'),
            ]"
            :paginator="paginator"
            @filter="submit"
        >

            <template #filters>
                <Input :placeholder="__('admin::forms.search')" v-model="filter.search" variant="filter" />
            </template>

            <template #results>
                <tr v-for="vacationMessageDefault in paginator.data" :key="vacationMessageDefault.id">
                    <td>{{ vacationMessageDefault.name }}</td>
                    <td>{{ vacationMessageDefault.priority }}</td>
                    <td>{{ vacationMessageDefault.is_active ? __('admin::labels.yes') : __('admin::labels.no') }}</td>
                    <td>
                        <TableButton
                            variant="edit"
                            :href="$route('admin::vacation-message-defaults.edit', { vacation_message_default: vacationMessageDefault.id })"
                        />
                        <TableButton
                            variant="destroy"
                            @delete="deleting = $route('admin::vacation-message-defaults.destroy', { vacation_message_default: vacationMessageDefault.id })"
                        />
                    </td>
                </tr>
            </template>

        </Table>

        <DeleteDialog
            :title="__('admin::general.delete_model', { model: __('admin::vacation-message-defaults.vacation-message-default') })"
            :url="deleting"
            v-if="deleting"
            @closed="deleting = null"
        />

    </IndexModelLayout>
</template>

<script>
    export default {
        props: {
            paginator: Object,
            request: Object,
        },
        data() {
            return {
                filter: this.$inertia.form({
                    search: this.request.search,
                }),
                deleting: null,
            }
        },
        methods: {
            submit() {
                this.filter.get(this.$route('admin::vacation-message-defaults.index'));
            },
        },
    }
</script>
